import { render, staticRenderFns } from "./WizardCartWindow.vue?vue&type=template&id=5017ca00"
import script from "./WizardCartWindow.vue?vue&type=script&lang=ts"
export * from "./WizardCartWindow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports